import React, { useState } from 'react';
import Icon from './AppIcon';
import Button from './ui/Button';

const TutorialAccessButton = ({ 
  className = '',
  onTutorialStart,
  tutorialProgress = 0
}) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const handleClick = () => {
    if (onTutorialStart) {
      onTutorialStart();
    }
  };

  const getProgressColor = () => {
    if (tutorialProgress === 0) return 'text-muted-foreground';
    if (tutorialProgress < 50) return 'text-warning';
    if (tutorialProgress < 100) return 'text-primary';
    return 'text-success';
  };

  const getProgressText = () => {
    if (tutorialProgress === 0) return 'Start Tutorial';
    if (tutorialProgress === 100) return 'Tutorial Complete';
    return `Continue Tutorial (${tutorialProgress}%)`;
  };

  return (
    <div className={`relative ${className}`}>
      <Button
        variant="outline"
        size="default"
        onClick={handleClick}
        onMouseEnter={() => setIsTooltipVisible(true)}
        onMouseLeave={() => setIsTooltipVisible(false)}
        onFocus={() => setIsTooltipVisible(true)}
        onBlur={() => setIsTooltipVisible(false)}
        iconName="GraduationCap"
        iconPosition="left"
        className="relative"
        aria-label={getProgressText()}
      >
        <span className="hidden sm:inline">{getProgressText()}</span>
        <span className="sm:hidden">Tutorial</span>
        {tutorialProgress > 0 && tutorialProgress < 100 && (
          <span className={`ml-2 ${getProgressColor()}`}>
            {tutorialProgress}%
          </span>
        )}
      </Button>

      {isTooltipVisible && (
        <div 
          className="absolute top-full right-0 mt-2 w-64 p-4 bg-popover border border-border rounded-xl shadow-warm-lg z-200"
          role="tooltip"
        >
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
              <Icon name="GraduationCap" size={20} color="var(--color-primary)" />
            </div>
            <div className="flex-1">
              <h4 className="text-sm font-semibold text-foreground mb-1">
                {tutorialProgress === 0 ? 'Get Started' : 'Continue Learning'}
              </h4>
              <p className="text-xs text-muted-foreground leading-relaxed">
                {tutorialProgress === 0 
                  ? 'Learn how to use DraftIQ agents effectively with our interactive tutorial.' : `You're ${tutorialProgress}% through the tutorial. Keep going to unlock all features!`
                }
              </p>
              {tutorialProgress > 0 && tutorialProgress < 100 && (
                <div className="mt-3">
                  <div className="w-full h-1.5 bg-muted rounded-full overflow-hidden">
                    <div 
                      className="h-full bg-primary transition-all duration-250"
                      style={{ width: `${tutorialProgress}%` }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @media (max-width: 768px) {
          .relative {
            position: fixed;
            bottom: 5rem;
            right: 1rem;
            z-index: 50;
          }
        }
      `}</style>
    </div>
  );
};

export default TutorialAccessButton;